jQuery(document).ready(function($){

  $('[data-stat]').each(function () {

    var done = false;
    var $this = $(this);
    var int = Number.isInteger(Number($this.text()));

    $this.waypoint(function(direction) {

      if ( !done ) {
        done = true;
        $this.prop('Counter', 0).animate({ Counter: $this.text() }, {
          duration: 2000,
          easing: 'swing',
          step: function (now) {
            $this.text(int ? Math.ceil(now) : this.Counter.toFixed(1));
          }
        });
      }

    }, { offset: '75%' });

  });

  $('.jsHeroSliderWrapper').each(function() {

    var $wrapper  = $(this);
    var $slider   = $wrapper.find('.jsHeroSlider');

    $slider.owlCarousel({
      items: 1,
      dots: false,
      autoplay: true,
      autoplayTimeout: 6000,
      loop: true,
      animateOut: 'fadeOut',
    });

  });

  if( $('.typed-give-text').length ){
    var typedGiveText = new Typed('.typed-give-text', {
        strings: typedGiveString,
        typeSpeed: 80,
        backSpeed: 20,
        backDelay: 3000,
        startDelay: 1000,
        fadeOut: false,
        loop: true
      });
  }

  if( $('.benefits-tabs').length ){
    var tabRunning = $('.benefits-tabs').attr('data-running-tab');
    var animatedLine = $('.benefits-tabs--upper .service-box-'+tabRunning).attr('data-animated-line');

    if ( window.matchMedia('(min-width: 1400px)').matches ) {
      $('.benefits-tabs--upper .animated-line .animated-line-part span').css({'width': '0%', 'height': '1px'});
    } else {
      $('.benefits-tabs--upper .animated-line .animated-line-part span').css({'height': '0%', 'width': '1px'});
    }

    if ( window.matchMedia('(min-width: 1400px)').matches ) {
      $(animatedLine).find('span').animate({
        width:'100%'
      }, 10000, "linear");
    } else {
      $(animatedLine).find('span').animate({
        height:'100%'
      }, 10000, "linear");
    }
    $('.benefits-tabs').attr('data-running-tab', parseInt(tabRunning)+1);
    var tabAnimationF = setInterval(tabAnimation, 10000);

  }

  function tabAnimation() {
    var tabRunning = $('.benefits-tabs').attr('data-running-tab');
    var allTabs = $('.benefits-tabs').attr('data-all-tabs');
    var tabDescription = $('.benefits-tabs--upper .service-box-'+tabRunning).attr('data-target');
    var animatedLine = $('.benefits-tabs--upper .service-box-'+tabRunning).attr('data-animated-line');

    $('.benefits-tabs--upper .service-box').removeClass('active-box');
    $('.benefits-tabs--upper .service-box-'+tabRunning).addClass('active-box');

    $('.benefits-tabs-lower .description-tabs .description-area').removeClass('active-description');
    $(tabDescription).addClass('active-description');

    if ( window.matchMedia('(min-width: 1400px)').matches ) {
      $('.benefits-tabs--upper .animated-line .animated-line-part span').css({'width': '0%', 'height': '1px'});
    } else {
      $('.benefits-tabs--upper .animated-line .animated-line-part span').css({'height': '0%', 'width': '1px'});
    }

    if ( window.matchMedia('(min-width: 1400px)').matches ) {
      $(animatedLine).find('span').animate({
        width:'100%'
      }, 9500, "linear");
    } else {
      $(animatedLine).find('span').animate({
        height:'100%'
      }, 9500, "linear");
    }

    $('.benefits-tabs').attr('data-running-tab', parseInt(tabRunning)+1);

    if ( window.matchMedia('(min-width: 1400px)').matches ) {
      $('.benefits-tabs--upper .animated-line .animated-line-part span').css({'width': '0%', 'height': '1px'});
    } else {
      $('.benefits-tabs--upper .animated-line .animated-line-part span').css({'height': '0%', 'width': '1px'});
    }

    if( parseInt(tabRunning) == parseInt(allTabs) ){
      abortTabAnimation();
    }
  }

  function abortTabAnimation() { // to be called when you want to stop the timer
    clearInterval(tabAnimationF);
  }

  $('.service-box .service-box--info, .service-box .service-box--text').click(function(){
    abortTabAnimation();
    $('.animated-line-part span').stop();
    $('.benefits-tabs--upper .animated-line .animated-line-part span').css('width', '0%');

    var index = $(this).parent().parent('.col').index() + 1;
    $('.benefits-tabs').attr('data-running-tab', parseInt(index));

    var allTabs = $('.benefits-tabs').attr('data-all-tabs');
    var tabRunning = $('.benefits-tabs').attr('data-running-tab');
    var animatedLine = $('.benefits-tabs--upper .service-box-'+index).attr('data-animated-line');

    $('.benefits-tabs--upper .service-box').removeClass('active-box');
    $('.benefits-tabs--upper .service-box-'+tabRunning).addClass('active-box');

    var tabDescription = $('.benefits-tabs--upper .service-box-'+tabRunning).attr('data-target');
    $('.benefits-tabs-lower .description-tabs .description-area').removeClass('active-description');
    $(tabDescription).addClass('active-description');

    if ( window.matchMedia('(min-width: 1400px)').matches ) {
      $(animatedLine).find('span').animate({
        width:'100%'
      }, 9500, "linear");
    } else {
      $(animatedLine).find('span').animate({
        height:'100%'
      }, 9500, "linear");
    }

    $('.benefits-tabs').attr('data-running-tab', parseInt(tabRunning)+1);

    if ( window.matchMedia('(min-width: 1400px)').matches ) {
      $('.benefits-tabs--upper .animated-line .animated-line-part span').css({'width': '0%', 'height': '1px'});
    } else {
      $('.benefits-tabs--upper .animated-line .animated-line-part span').css({'height': '0%', 'width': '1px'});
    }
    if( parseInt(tabRunning) < parseInt(allTabs) ){
      tabAnimationF = setInterval(tabAnimation, 10000);
    }

  });

  $('.jsBannerSlider').each(function () {

    var $slider = $(this);
    // var $nav    = $slider.find('.jsBannerSliderNav');

    $slider.owlCarousel({
      items: 1,
      dots: false,
      autoplay: true,
      autoplayTimeout: 8000,
      autoplaySpeed: 2000,
      autoplayHoverPause: true,
      loop: true,
      margin: 40,
      centerMode: true
    });

    $slider.on('click', '.jsBannerSliderNav .arrow', function(e) {
      e.preventDefault();

      $slider.trigger(($(this).hasClass('arrow-left') ? 'prev' : 'next') + '.owl.carousel');
    });

  });

  $('.jsFooterWidgetTitle').click(function() {
    $(this).toggleClass('active');
    $(this).parent().find('.footer-menu').slideToggle();
  });

  $('.jsMobileMenuToggle').click(function(e) {
    e.preventDefault();
    $('.jsMobileMenu').toggleClass('active');
    $('body').toggleClass('overflow-hidden');
  });

  $('.mobile-primary-menu > li.menu-item-has-children > a').on('click', function(e) {
    e.preventDefault();

    $(this).toggleClass('is-active');
    $(this).parent().find('.sub-menu').slideToggle();
  });

  $('.service-box--info').click(function() {
    $('.benefit-modal').removeClass('active');
    $('.benefit-modal[data-index="' + $(this).parent().data('index') + '"]').addClass('active');
  });

  $('.jsBenefitModalClose').click(function(e) {
    e.preventDefault();
    $(this).parent().parent().removeClass('active');
  });

  $('.mobile-main-menu .menu-item-has-children > a').click(function(e) {
    e.preventDefault();

    if ( $(this).parent().children('.sub-menu').find('.sub-menu__title').length == 0 ) {
      $(this).parent().children('.sub-menu').prepend(
        '<li class="sub-menu__title"><a href="' + $(this).attr('href') + '">' + $(this).text() + '</a></li>');
    }

    $(this).parent().children('.sub-menu').addClass('active');
    $('.jsMobileMenuBack').addClass('active');
  });

  $('.jsMobileMenuBack').click(function(e) {
    e.preventDefault();
    $('.mobile-main-menu .sub-menu').removeClass('active');
    $(this).removeClass('active');
  });

  $('.jsSidebarAwardsSlider').each(function() {

    var $slider   = $(this);
    var $nav      = $slider.parent().find('.jsSidebarAwardsSliderNav');

    $slider.owlCarousel({
      dots: false,
      loop: true,
      nav: false,
      items: 1,
      slideBy: 1,
    });

    $nav.find('a').click(function(e) {
      e.preventDefault();

      $slider.trigger(($(this).data('dir') == 'left' ? 'prev' : 'next') + '.owl.carousel');
    });

  });

  $('.jsBookChapterCaption').on('click', function(e) {
    e.preventDefault();

    $(this).parent().toggleClass('active');
    $(this).parent().find('.jsBookChapterContent').slideToggle();
  });

  jQuery('.jsAwardsSlider').each(function() {

    var $slider   = jQuery(this);
    var $nav      = $slider.parent().find('.jsAwardsSliderNav');

    $slider.owlCarousel({
      dots: false,
      loop: true,
      nav: false,
      items: 1,
      slideBy: 1,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplaySpeed: 1000,
      responsive: {
        0 : {
          items: 1,
        },
        500: {
          items: 2,
        },
        768: {
          items: 3,
        },
        1000: {
          items: 4,
        },
        1200: {
          items: 5,
        }
      }
    });

    $nav.find('a').click(function(e) {
      e.preventDefault();

      $slider.trigger((jQuery(this).data('dir') == 'left' ? 'prev' : 'next') + '.owl.carousel');
    });

  });

    // Clients slider
    $('.jsClientsSlider').each(function() {

        var $slider  = $(this);

        $slider.owlCarousel({
            items: 9,
            dots: false,
            autoplay: true,
            autoplayTimeout: 3000,
            autoplaySpeed: 1000,
            loop: true,
            animateOut: 'fadeOut',
            margin: 20,
            responsive: {
                0 : {
                    items: 2,
                },
                400: {
                    items: 3,
                },
                550: {
                    items: 4,
                },
                768: {
                    items: 6,
                },
                1200: {
                    items: 9,
                }
            }
        });

    });

    // Dropdown menu
    $( function() {
        var $trigger = $( '.js-primary-menu-submenu-trigger' );
        var $submenu = $( '.js-primary-menu-submenu' );
        var $list = $( '.js-primary-menu-list' );

        $trigger.on( 'mouseenter', function() {
            $( this ).closest( $submenu ).addClass( 'is-active' );
            if ( $( this ).hasClass( 'primary-menu-submenu__item--two-columns' ) ) {
                $( this ).closest( $submenu ).addClass( 'is-active--two-columns' );
            }
            if ($( this ).parents( '.primary-menu-submenu--level-2' ).length) {
                $( this ).parents( '.primary-menu-submenu--level-1' ).addClass( 'is-active--two-columns' );
            }
            $( this ).closest( $list ).first().css( 'min-height', $( this ).find( $list ).first().height() + 'px' );
        } ).on( 'mouseleave', function() {
            $( this ).closest( $submenu ).removeClass( 'is-active' );
            $( this ).parents( $submenu ).removeClass( 'is-active--two-columns' );
            $( this ).closest( $list ).first().css( 'min-height', '' );
        } );
    } );

    //Smooth scroll
    $( function() {
        $( 'a[href*="#"]' )
        // Remove links that don't actually link to anything
            .not( '[href="#"]' )
            .not( '[href="#0"]' )
            .on( 'click', function( event ) {
                // On-page links
                if (
                    location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' )
                    &&
                    location.hostname === this.hostname
                ) {
                    // Figure out element to scroll to
                    var target = $( this.hash );
                    target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) + ']' );
                    // Does a scroll target exist?
                    if ( target.length ) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();
                        $( 'html, body' ).animate( {
                            scrollTop: target.offset().top
                        }, 1000, function () {
                            // Callback after animation
                            // Must change focus!
                            var $target = $( target );
                            $target.focus();
                            if ( $target.is( ":focus" ) ) { // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr( 'tabindex', '-1' ); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            }
                        } );
                    }
                }
            } );
    } );

    $('.jsServicesCardsSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];

			let swiper = new Swiper($slider, {
				...getSwiperDefaults('.jsServicesCardsSliderNavArrow'),
				loop: false,
				slidesPerView: 1,
				spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1200: {
						slidesPerView: 4,
						spaceBetween: 60
					}
        }
			});
		});

    $('.jsClientsLogosSlider').each(function() {
			let $wrapper = $(this);
			let $slider = $wrapper.find('.swiper')[0];

			let swiper = new Swiper($slider, {
				direction: 'horizontal',
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
				loop: false,
				slidesPerView: 2,
				spaceBetween: 40,
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 60,
          },
          1200: {
						slidesPerView: 7,
						spaceBetween: 100
					}
        }
			});
		});

  // Initialize headroom
	(new Headroom(document.querySelector('.main-header'))).init();
});

const getSwiperDefaults = (navExtraClass = '') => ({
  direction: 'horizontal',
  disableOnInteraction: false,
  pauseOnMouseEnter: false,
  navigation: {
    nextEl: `${navExtraClass}.swiper-nav-next`,
    prevEl: `${navExtraClass}.swiper-nav-prev`,
  }
});

jQuery(window).on('load resize', function(e) {

  if ( window.matchMedia('(max-width: 1399px)').matches ) {
    var l = jQuery('.benefits-tabs--upper .service-box').length;
    var h = 0;
    var hArray = [];
    jQuery('.benefits-tabs--upper .service-box').each(function(index, item) {
      if ( index < l - 1 ) {
        h = h + jQuery(this).outerHeight(true);
        hArray.push(jQuery(this).outerHeight(true));
        // console.log(h);
        // console.log(hArray);
      }
    });
    // console.log(h);
    jQuery('.jsAnimatedLine').css('height', h + 'px');
    jQuery('.jsAnimatedLine .animated-line-part').each(function(index, item){
      if ( index < l - 1 ) {
        jQuery(this).css('height', hArray[index] + 'px');
      }
    });
  } else {
    jQuery('.jsAnimatedLine').attr('style', '');
  }

});

( function( $, window ) {
    'use strict';

    $( function() {
        var $waypoint = $( '.js-waypoint' );
        var waypointVisible = 'is-visible';

        if ( window.matchMedia( '(min-width: 768px)' ) ) {
            $waypoint.each( function() {
                $( this ).waypoint( {
                    handler: function() {
                        $( this.element ).addClass( waypointVisible );
                        this.destroy();
                    },
                    offset: '90%'
                } );
            } );
        } else {
            $waypoint.addClass( waypointVisible );
        }
    } );
} )( jQuery, window );
